import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  PaymentStatus,
  PaymentStatuses,
  PaymentVerificationStatus,
} from '@techspert-io/engagements';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { PaymentStatusPipe } from '../../../../shared/pipes/payment-status.pipe';
import { SentenceCasePipe } from '../../../../shared/pipes/sentence-case.pipe';

export type PaymentStatusForm = FormGroup<{
  paymentStatuses: FormControl<PaymentStatus[]>;
  verificationStatus: FormControl<PaymentVerificationStatus>;
}>;

@Component({
  selector: 'app-payment-status-form',
  templateUrl: './payment-status-form.component.html',
  styleUrls: ['./payment-status-form.component.scss'],
  imports: [MaterialModule, SentenceCasePipe, PaymentStatusPipe],
})
export class PaymentStatusFormComponent implements OnInit {
  @Input() parentForm: FormGroup<{ status?: PaymentStatusForm }>;

  get paymentStatuses() {
    return PaymentStatuses;
  }

  get verificationStatuses() {
    return Object.values(PaymentVerificationStatus);
  }

  get statusForm() {
    return this.parentForm.controls.status;
  }

  get paymentStatusesControl() {
    return this.statusForm.controls.paymentStatuses;
  }

  get verificationStatusControl() {
    return this.statusForm.controls.verificationStatus;
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.parentForm.addControl(
      'status',
      this.fb.group({
        paymentStatuses: [
          ['not-paid'],
          [Validators.required, Validators.minLength(1)],
        ],
        verificationStatus: [
          PaymentVerificationStatus.Verified,
          Validators.required,
        ],
      })
    );
  }
}
